import {
	P_IVA,
	RAG_SOCIALE,
	REA,
	SITE,
} from "../../../utils/const.js";

/**------------- Contacts Footer constants -------------**/

/*  General  */
export const CONTACTS_FOOTER_TEXT_CLASS_NAME =
	"contacts-footer-text";

/*  Footer Texts  */
export const CONTACTS_FOOTER_TEXT =
	RAG_SOCIALE +
	". " +
	SITE +
	". P. IVA: " +
	P_IVA +
	". REA: " +
	REA +
	".";
export const LEGAL_NOTES_TEXT = "NOTE LEGALI";

/*  Links  */
export const LEGAL_NOTES_LINK =
	"/docs/Note%20Legali%20-%20Auto%20Usate%20-%20MM%20Eletricar%20Service.pdf";
